<template>
  <div class="saleSampleProfitAsMix">
    <el-form class="form" label-width="auto">
      <el-form-item>
        <h1 style="margin-right: 20px;">利润核算单 - 配比吨数</h1>
        <el-button-group style="margin-right: 20px;">
          <el-button @click="router.go(-1)">返回</el-button>
          <el-button type="info" @click="exportExcel()">导出</el-button>
        </el-button-group>
        <el-switch v-model="searchParam.hasStorage" active-text="区分仓储" @change="search" />
      </el-form-item>
    </el-form>
    <el-table :data="data.list" ref="tabRef" border show-summary :summary-method="summary" style="height: calc(100vh - 220px);">
      <el-table-column prop="storage" label="仓储" width="120" show-overflow-tooltip v-if="show.tableStorage" />
      <el-table-column prop="product" label="品名" width="240" show-overflow-tooltip />
      <el-table-column prop="sendQuantity" label="原发数量" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.sendQuantity) }}
        </template>
      </el-table-column>
      <el-table-column prop="sampleQuantity" label="送达数量" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.sampleQuantity) }}
        </template>
      </el-table-column>
      <el-table-column prop="lossQuantity" label="亏吨" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.lossQuantity) }}
        </template>
      </el-table-column>
      <el-table-column prop="lossQuantityRate" label="亏吨率" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(math.multiply(scope.row.lossQuantityRate, 100)) + '%' }}
        </template>
      </el-table-column>
      <el-table-column prop="saleProfitAmount" label="销售净利润" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.saleProfitAmount) }}
        </template>
      </el-table-column>
      <el-table-column prop="businessProfitPrice" label="测算利润单价" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.businessProfitPrice) }}
        </template>
      </el-table-column>
      <el-table-column prop="profitPrice" label="净利润单价" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.profitPrice) }}
        </template>
      </el-table-column>
      <el-table-column prop="settlePrice" label="结算单价" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.settlePrice) }}
        </template>
      </el-table-column>
      <el-table-column prop="procureProductPrice" label="采购单价" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.procureProductPrice) }}
        </template>
      </el-table-column>
      <el-table-column prop="procureProductAmount" label="采购金额" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.procureProductAmount) }}
        </template>
      </el-table-column>
      <el-table-column prop="procureTransportPrice" label="上游运输单价" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.procureTransportPrice) }}
        </template>
      </el-table-column>
      <el-table-column prop="procureTransportAmount" label="上游运输金额" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.procureTransportAmount) }}
        </template>
      </el-table-column>
      <el-table-column prop="saleTransportPrice" label="下游运输单价" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.saleTransportPrice) }}
        </template>
      </el-table-column>
      <el-table-column prop="dispatchPrice" label="单位调度费" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.dispatchPrice) }}
        </template>
      </el-table-column>
      <el-table-column prop="salePriceTransportTax" label="单位运费补税" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.salePriceTransportTax) }}
        </template>
      </el-table-column>
      <el-table-column prop="salePriceProfitTax" label="单位利润补税" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.salePriceProfitTax) }}
        </template>
      </el-table-column>
      <el-table-column prop="salePriceSuodeTax" label="单位所得税" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.salePriceSuodeTax) }}
        </template>
      </el-table-column>
      <el-table-column prop="salePriceEstimatedCost" label="单位预估费用" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.salePriceEstimatedCost) }}
        </template>
      </el-table-column>
      <el-table-column prop="diweifareliangKc" label="平均热大卡" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.diweifareliangKc) }}
        </template>
      </el-table-column>
      <el-table-column prop="quanliu" label="平均全硫" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.quanliu) }}
        </template>
      </el-table-column>
      <el-table-column prop="huifafen" label="平均挥发分" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.huifafen) }}
        </template>
      </el-table-column>
      <el-table-column prop="sumSalePriceTax" label="单位税金合计" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.sumSalePriceTax) }}
        </template>
      </el-table-column>
      <el-table-column prop="salePriceZengzhiTax" label="单位增值税" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.salePriceZengzhiTax) }}
        </template>
      </el-table-column>
      <el-table-column prop="salePriceFujiaTax" label="单位附加税" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.salePriceFujiaTax) }}
        </template>
      </el-table-column>
      <el-table-column prop="salePriceYinhuaTax" label="单位印花税" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.salePriceYinhuaTax) }}
        </template>
      </el-table-column>
    </el-table>
    <div style="height: 10px;" />
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '../../apis/api'
import apiNative from '../../apis/apiNative'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const router = useRouter()
const tabRef = ref()

const data = reactive({
  accumulate: {},
  list: [],
})

const show = reactive({
  tableStorage: false,
})

const searchParam = reactive({})
searchParam.hasStorage = false

const search = () => {
  api.get('/backend/saleSample/getProfitAsProduct', { params: searchParam }).then(res => {
    data.list = res.list
    data.accumulate = res.accumulate
    if (searchParam.hasStorage) {
      show.tableStorage = true
    } else {
      show.tableStorage = false
    }
  })
}

const pageParam = cache.getObject(cache.keys.pageParam + "saleSampleProfitAsProduct")
if (!pageParam || !pageParam.id) {
  router.go(-1)
} else {
  searchParam.id = pageParam.id
  search()
}

const summary = () => {
  const summary = []
  summary.push('合计')
  if (show.tableStorage) {
    summary.push('')
  }
  summary.push(math.formatNumber(data.accumulate.sendQuantity))
  summary.push(math.formatNumber(data.accumulate.sampleQuantity))
  summary.push(math.formatNumber(data.accumulate.lossQuantity))
  summary.push(math.formatNumber(math.multiply(data.accumulate.lossQuantityRate, 100)) + '%')
  summary.push(math.formatNumber(data.accumulate.saleProfitAmount))
  summary.push(math.formatNumber(data.accumulate.businessProfitPrice))
  summary.push(math.formatNumber(data.accumulate.profitPrice))
  summary.push(math.formatNumber(data.accumulate.settlePrice))
  summary.push(math.formatNumber(data.accumulate.procureProductPrice))
  summary.push(math.formatNumber(data.accumulate.procureProductAmount))
  summary.push(math.formatNumber(data.accumulate.procureTransportPrice))
  summary.push(math.formatNumber(data.accumulate.procureTransportAmount))
  summary.push(math.formatNumber(data.accumulate.saleTransportPrice))
  summary.push(math.formatNumber(data.accumulate.dispatchPrice))
  summary.push(math.formatNumber(data.accumulate.salePriceTransportTax))
  summary.push(math.formatNumber(data.accumulate.salePriceProfitTax))
  summary.push(math.formatNumber(data.accumulate.salePriceSuodeTax))
  summary.push(math.formatNumber(data.accumulate.salePriceEstimatedCost))
  summary.push(math.formatNumber(data.accumulate.diweifareliangKc))
  summary.push(math.formatNumber(data.accumulate.quanliu))
  summary.push(math.formatNumber(data.accumulate.huifafen))
  summary.push(math.formatNumber(data.accumulate.sumSalePriceTax))
  summary.push(math.formatNumber(data.accumulate.salePriceZengzhiTax))
  summary.push(math.formatNumber(data.accumulate.salePriceFujiaTax))
  summary.push(math.formatNumber(data.accumulate.salePriceYinhuaTax))
  return summary
}

const exportExcel = () => {
  const params = searchParam
  if (!params) {
    return
  }
  ElMessageBox.confirm('', {
    title: '确认导出',
    message: '将要按照当前选择的查询条件进行导出。',
    autofocus: false,
    confirmButtonText: '确认',
    cancelButtonText: '取消'
  }).then(() => {
    ElMessage.success('正在导出！如果数据量大可能时间较长，请耐心等待。')
    apiNative.get('/backend/saleSample/exportProfitAsProduct', {
      params: params,
      responseType: 'blob'
    }).then(res => {
      ElMessage.success('开始下载')
      util.downloadFile(res, '利润核算单-配比吨数' + util.parseTime(new Date(), '{y}{m}{d}{h}{i}{s}'), 'xlsx')
    }).catch(() => {
      ElMessage.error('导出失败，请联系系统管理员')
    })
  })
}
</script>

<style lang="less"></style>